import { mediaQueries, useCookieConsent, useSso } from '@tallink/components-lib'
import React from 'react'
import { hot } from 'react-hot-loader/root'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import { useEffectOnce, useMedia } from 'react-use'

import {
  getDetailedUserInfo,
  loggedInClubOne,
  loggedOutClubOne,
  setApiError,
  ssoErrorOccurred,
  ssoRendered
} from './actions/actions'
import SerialTicketsClient from './clients/SerialTicketsClient'
import ErrorBoundary from './components/common/ErrorBoundary'
import CompanyCustomerLoginPage from './components/companyCustomerLogin/CompanyCustomerLoginPage'
import PaymentAndDelivery from './components/PaymentAndDelivery/PaymentAndDelivery'
import { getEnv, getEnvBasedConfig } from './config/config'
import ConfirmationPage from './pages/ConfirmationPage'
import CouponPage from './pages/CouponPage'
import MainPage from './pages/MainPage'
import VoucherPage from './pages/VoucherPage'

function App() {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const location = useLocation()
  const smUp = useMedia(mediaQueries.smUp, true)

  SerialTicketsClient.init({
    errorHandler: error => dispatch(setApiError(error)),
    locale: i18n.language,
    url: getEnvBasedConfig().serialTicketsUrl,
    paymentServiceUrl: getEnvBasedConfig().paymentServiceUrl
  })

  const isOnCouponsPage = !!useRouteMatch('/coupons')
  const hasClientGuidInUrl = new URLSearchParams(location.search).has('clientGuid')
  const hasResTokenInUrl = new URLSearchParams(location.search).has('resToken')

  useSso({
    containerSelector: '#singleSignOnContainer',
    errorHandler: error => dispatch(setApiError(error)),
    hideAuthButton: !smUp,
    isMobile: !smUp,
    language: i18n.language,
    onError: () => dispatch(ssoErrorOccurred()),
    onGetUser: () => {
      dispatch(getDetailedUserInfo(isOnCouponsPage && !hasClientGuidInUrl && !hasResTokenInUrl))
    },
    onRender: () => dispatch(ssoRendered()),
    onSignIn: (token, userId) => {
      dispatch(
        loggedInClubOne({ token, userId, clearCoupons: isOnCouponsPage && !hasClientGuidInUrl && !hasResTokenInUrl })
      )
    },
    onSignOut: () => {
      dispatch(loggedOutClubOne({ clearCoupons: isOnCouponsPage && !hasClientGuidInUrl && !hasResTokenInUrl }))
    },
    url: getEnvBasedConfig().ssoUrl
  })

  useCookieConsent({
    env: 'serial-tickets',
    hostEnv: getEnv(),
    language: i18n.language
  })

  useEffectOnce(() => {
    const handlePageShowEvent = event => {
      if (event.persisted) {
        window.location.reload()
      }
    }

    window.history.scrollRestoration = 'manual'
    window.addEventListener('pageshow', handlePageShowEvent)

    return () => window.removeEventListener('pageshow', handlePageShowEvent)
  })

  return (
    <ErrorBoundary>
      <div className="sso-container">
        <div id="singleSignOnContainer" />
      </div>
      <Switch>
        <Route component={MainPage} exact path="/" />
        <Route component={MainPage} exact path="/giftcards" />
        <Route component={ConfirmationPage} path="/confirmation" />
        <Route component={CouponPage} path="/coupons" />
        <Route component={PaymentAndDelivery} exact path="/buy" />
        <Route component={VoucherPage} exact path="/voucher" />
        <Route component={CompanyCustomerLoginPage} exact path="/companyCustomer" />
        <Redirect from="*" to="/" />
      </Switch>
    </ErrorBoundary>
  )
}

export default process.env.NODE_ENV === 'development' ? hot(App) : App
